/**
 * Swiper dependencies
 *
 * @see https://swiperjs.com/get-started
 */
import { Swiper } from 'swiper';
// eslint-disable-next-line import/no-unresolved
import { Autoplay, Keyboard, Scrollbar } from 'swiper/modules';
/**
 * Initialize the slider.
 *
 * @param {Element} container HTMLElement.
 *
 * @return {Object} Returns initialized slider instance.
 *
 * @see https://swiperjs.com/swiper-api#parameters
 */
export function SwiperInit(container) {
	const parameters = {
		slidesPerView: 1,
		spaceBetween: 20,
		loop: false,
		autoHeight: true,
		calculateHeight: true,
		autoplay: false,
		initialSlide: 0,
		keyboard: true,
		modules: [Autoplay, Keyboard, Scrollbar],
		scrollbar: {
			el: '.rlt-our-vision-scrollbar',
			draggable: true,
		},
		simulateTouch: true,
	};

	return new Swiper(container, parameters);
}
